import { format, isValid, parse } from "date-fns";

export const money = (value) =>
  Number(value || 0).toLocaleString("en-PK", { maximumFractionDigits: 2 });

export const parseOrderDate = (value, dateOnly = false) => {
  if (!value) return null;
  if (value instanceof Date) return isValid(value) ? value : null;
  const parsed = parse(
    value,
    dateOnly ? "yyyy-MM-dd" : "yyyy-MM-dd HH:mm:ss",
    new Date()
  );
  if (isValid(parsed)) return parsed;
  const fallback = new Date(value);
  return isValid(fallback) ? fallback : null;
};

export const orderDate = (value, pattern, dateOnly = false) => {
  const parsed = parseOrderDate(value, dateOnly);
  return parsed ? format(parsed, pattern) : "—";
};

export const paymentLabel = (method) =>
  ({
    cash_on_delivery: "COD",
    card_on_delivery: "CCOD",
    wallet_on_delivery: "Wallet",
    up_front_cash_payment: "Cash",
  }[method] || "Digital");

export const bookingLabel = (details) => {
  if (Number(details?.booking_type) === 1) return "Regular";
  if (Number(details?.booking_type) === 2) return "Express";
  return details?.laundry_delivery_type?.id === 3
    ? "Come & Collect"
    : details?.laundry_delivery_type?.title || "Regular";
};

export const parseNotes = (note) => {
  if (!note) return [];
  if (Array.isArray(note)) return note;
  if (typeof note !== "string") return [];
  try {
    const parsed = JSON.parse(note);
    return Array.isArray(parsed) ? parsed : [{ note: String(parsed) }];
  } catch {
    return note
      .split(",")
      .map((value) => ({ note: value.trim() }))
      .filter((value) => value.note);
  }
};

const trackFields = [
  ["pending", "Booked"],
  ["confirmed", "Confirmed"],
  ["out_for_pickup", "Out For Pickup"],
  ["picked_up", "Picked Up"],
  ["arrived", "Arrived"],
  ["processing", "Processing"],
  ["ready_for_delivery", "Ready For Delivery"],
  ["out_for_delivery", "Out For Delivery"],
  ["delivered", "Delivered"],
  ["deferred_at", "Deferred"],
  ["cancelled", "Cancelled"],
  ["failed", "Failed"],
];

export const buildTrack = (data) =>
  trackFields.reduce((records, [field, status]) => {
    const parsed = parseOrderDate(data?.[field]);
    if (parsed) {
      records.push({
        status,
        time: format(parsed, "p"),
        date: format(parsed, "eee, dd MMM yyyy"),
      });
    }
    return records;
  }, []);

export const progressIndex = (details) => {
  const status = details?.order_status;
  if (status === "delivered" || details?.delivered) return 5;
  if (status === "out_for_delivery" || details?.out_for_delivery) return 4;
  if (
    ["picked_up", "arrived", "processing", "ready_for_delivery"].includes(status) ||
    details?.picked_up || details?.processing || details?.ready_for_delivery
  ) return 3;
  if (
    ["confirmed", "out_for_pickup", "schedule"].includes(status) ||
    details?.confirmed || details?.out_for_pickup
  ) return 2;
  return 1;
};

export const statusLabel = (status) =>
  ({
    pending: "Booked",
    schedule: "Booked",
    confirmed: "Confirmed",
    out_for_pickup: "Out for Pickup",
    picked_up: "Picked Up",
    arrived: "Arrived",
    processing: "In Process",
    ready_for_delivery: "Ready for Delivery",
    out_for_delivery: "Out for Delivery",
    delivered: "Delivered",
    deferred: "Deferred",
    cancelled: "Cancelled",
    failed: "Failed",
  }[status] || status || "Booked");
